export default "__VITE_ASSET__iOo2Y4qr__"